import { MutableRefObject } from 'react';
import { atom } from 'jotai';
import { LoadedGameAssets } from './assetConfig';

const createEmptyAssets = (): LoadedGameAssets => ({
  videos: {},
  images: {},
  jsonData: {},
  riveFiles: {},
  fonts: {},
  customAnimations: {},
});

export const globalAssetsRef: MutableRefObject<LoadedGameAssets> = {
  current: createEmptyAssets(),
};

export const assetsVersionAtom = atom(0);
export const assetsReadyAtom = atom(false);
